import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchScheduleSaveToLibrarySuggestionArgs,
  FetchOrgScheduleArgs,
  FetchScheduleArgs,
} from '../api/types/schedule.types';

import {
  fetchScheduleSaveToLibrarySuggestion,
  fetchOrgSchedule,
  fetchEvents,
} from '../api/schedule.api';

export const scheduleQueryKeys = createQueryKeys('schedule', {
  fetchScheduleSaveToLibrarySuggestion: ({
    eventId,
    organizationId,
  }: FetchScheduleSaveToLibrarySuggestionArgs) => ({
    queryFn: () =>
      fetchScheduleSaveToLibrarySuggestion({ eventId, organizationId }),
    queryKey: [organizationId, eventId],
  }),
  fetchOrgSchedule: ({
    from,
    locale,
    organizationId,
    to,
  }: FetchOrgScheduleArgs) => ({
    queryFn: () => fetchOrgSchedule({ from, locale, organizationId, to }),
    queryKey: [organizationId, from, to],
  }),
  fetchSchedule: ({
    clientId,
    from,
    locale,
    organizationId,
    perspective,
    to,
    withMyScheduleOnly,
  }: FetchScheduleArgs) => ({
    queryFn: () =>
      fetchEvents({
        clientId,
        from,
        locale,
        organizationId,
        perspective,
        to,
        withMyScheduleOnly,
      }),
    queryKey: [
      withMyScheduleOnly,
      organizationId,
      clientId,
      from,
      to,
      perspective,
    ],
  }),
});
